import BaseController from "confinus_ui/base_controller";

export default class PublishOrScheduleController extends BaseController {
  static targets = [
    "publishCard",
    "scheduleCard",
    "scheduleFields",
    "submitButton",
    "submitLabel",
    "submitIcon",
    "requiresScheduled",
    "publishRing",
    "publishDot",
    "scheduleRing",
    "scheduleDot",
  ];

  declare readonly publishCardTarget: HTMLElement;
  declare readonly scheduleCardTarget: HTMLElement;
  declare readonly scheduleFieldsTarget: HTMLElement;
  declare readonly submitButtonTarget: HTMLButtonElement;
  declare readonly submitLabelTarget: HTMLElement;
  declare readonly submitIconTarget: HTMLElement;
  declare readonly requiresScheduledTarget: HTMLInputElement;
  declare readonly publishRingTarget: HTMLElement;
  declare readonly publishDotTarget: HTMLElement;
  declare readonly scheduleRingTarget: HTMLElement;
  declare readonly scheduleDotTarget: HTMLElement;

  private static readonly SELECTED_CARD =
    "flex items-start gap-3 p-4 rounded-lg cursor-pointer transition-colors duration-fast border-2 border-primary-500 bg-primary-50";
  private static readonly UNSELECTED_CARD =
    "flex items-start gap-3 p-4 rounded-lg cursor-pointer transition-colors duration-fast border border-hairline-strong bg-white";

  public selectPublish(): void {
    this.requiresScheduledTarget.value = "false";

    this.publishCardTarget.className =
      PublishOrScheduleController.SELECTED_CARD;
    this.scheduleCardTarget.className =
      PublishOrScheduleController.UNSELECTED_CARD + " mt-2";

    this.publishRingTarget.classList.add("border-primary-500");
    this.publishRingTarget.classList.remove("border-gray-300");
    this.publishDotTarget.classList.remove("hidden");

    this.scheduleRingTarget.classList.remove("border-primary-500");
    this.scheduleRingTarget.classList.add("border-gray-300");
    this.scheduleDotTarget.classList.add("hidden");

    this.scheduleFieldsTarget.classList.add("hidden");

    this.submitLabelTarget.textContent = "Publish now";
    this.submitIconTarget.classList.add("hidden");
    // Turbo's confirm attribute (the app runs UJS-free); immediate publishes
    // get a confirmation, scheduled ones do not.
    this.submitButtonTarget.setAttribute(
      "data-turbo-confirm",
      "Are you sure you want to immediately publish this price change to your customers?",
    );
  }

  public selectSchedule(): void {
    this.requiresScheduledTarget.value = "true";

    this.scheduleCardTarget.className =
      PublishOrScheduleController.SELECTED_CARD + " mt-2";
    this.publishCardTarget.className =
      PublishOrScheduleController.UNSELECTED_CARD;

    this.scheduleRingTarget.classList.add("border-primary-500");
    this.scheduleRingTarget.classList.remove("border-gray-300");
    this.scheduleDotTarget.classList.remove("hidden");

    this.publishRingTarget.classList.remove("border-primary-500");
    this.publishRingTarget.classList.add("border-gray-300");
    this.publishDotTarget.classList.add("hidden");

    this.scheduleFieldsTarget.classList.remove("hidden");

    this.submitLabelTarget.textContent = "Schedule update";
    this.submitIconTarget.classList.remove("hidden");
    this.submitButtonTarget.removeAttribute("data-turbo-confirm");
  }
}
